import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { MtProjectGroup } from "server/models"
import { deepCopy } from "client/utils"
import {
    StoreType,
    setNotAssignedProjectUserGroupSelected,
} from "client/store"
import {
    Default,
    TableColumn,
} from "client/components"

const Columns = () => {
    const selected = useSelector((state: StoreType) => state.projectUserGroup.notAssignedGroups.selected)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const selectGroup = (group: MtProjectGroup) => {
        let selectedCopy
        if (selected && selected.includes(group.groupId)) {
            selectedCopy = selected.filter((id) => (id !== group.groupId))
        } else {
            selectedCopy = selected ? deepCopy(selected) : []
            selectedCopy.push(group.groupId)
        }
        dispatch(setNotAssignedProjectUserGroupSelected(selectedCopy))
    }

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
            formatter: (group: MtProjectGroup) => group.groupId,
            onClick: selectGroup,
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "150px",
            formatter: (group: MtProjectGroup) => (
                <>
                    {group.name}
                    {group.default && <Default marginLeft />}
                </>
            ),
            onClick: selectGroup,
        },
        {
            field: "description",
            header: lang.description,
            cellMinWidth: "200px",
            cellMaxWidth: "300px",
            onClick: selectGroup,
        },
    ]

    return columns
}
export default Columns
